<template>
    <section class="page-blog-mag-details">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <m-blog-details />
                </div>
            </div>
        </div>
    </section>
</template>

<script>

import MBlogDetails from 'cp/blog/details.vue'

export default {
    name: 'page-blog-mag-details',
    components: {
        MBlogDetails
    }
}
</script>


// WEBPACK FOOTER //
// src/pages/blog/_id.vue